import React, { useEffect } from "react";
import { Form, Input, DatePicker, Col, Row, Space, Tabs } from "antd";
import { SaveOutlined, TeamOutlined } from "@ant-design/icons";
import { getAllUsersToSelect } from "Api/UsersApi/helpers";
import { ChooseWorks } from "../ChooseWorks/ChooseWorks";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBlank,
  setChangeValue,
  setChangeMaterialsValue,
  setDate,
  setDescription,
  setSelectedMaterials,
  setSelectedWorks,
  setUsers,
  setWorkTime,
  setCommentData,
  findUsersFromLastBlank,
} from "AppStore/Slices/BlankSlice/BlankSlice";
import dayjs from "dayjs";
import { SearchSelectDebounce } from "Components/SearchSelectDebounce/SearchSelectDebounce";
import { MyText } from "Components/MyText/MyText";
import { MyTimePicker } from "Components/MyTimePicker/MyTimePicker";
import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { defaultSettings } from "css/defaultAntStyles";
import { getAllMaterialsForProjectToSelect } from "Api/ProjectApi/helpers";
import { useDroppable } from "@dnd-kit/core";
const { TextArea } = Input;

export const CreateBlankForm = ({
  form,
  onFinish,
  disabled = false,
  isCanCreate = () => {},
  onSaveData,
  activeItem = null,
}) => {
  const {
    description,
    workDate,
    users,
    selectedWorks,
    startTime,
    endTime,
    blankMaterials,
  } = useSelector(selectBlank);
  useEffect(() => {
    if (
      !description ||
      !workDate ||
      !users.length ||
      !selectedWorks.length ||
      !startTime ||
      !endTime
    ) {
      isCanCreate(false);
    } else {
      isCanCreate(true);
    }
  }, [description, workDate, users, selectedWorks, startTime, endTime]);
  const dispatch = useDispatch();
  const worksDrop = useDroppable({
    id: "works-drop-create",
    data: {
      type: "works",
    },
  });

  // Вкладка Матеріали
  const materialsDrop = useDroppable({
    id: "materials-drop-create",
    data: {
      type: "materials",
    },
  });

  const { setNodeRef: setWorksNodeRef, isOver: isWorksOver } = worksDrop;

  const { setNodeRef: setMaterialsNodeRef, isOver: isMaterialsOver } =
    materialsDrop;

  useEffect(() => {
    dispatch(findUsersFromLastBlank());
  }, []);

  return (
    <Form layout="vertical" form={form} onFinish={onFinish}>
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <MyBtnConfirm
          icon={
            <SaveOutlined style={{ color: defaultSettings.colorPrimary }} />
          }
          btnIcon={<SaveOutlined />}
          type=""
          mainTitle="Зберегти бланк?"
          fontSize={"18px"}
          onConfirm={onSaveData}
        />
      </div>
      <Col span={24}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Час виконання робіт" name="workTime">
              <Space>
                <MyTimePicker
                  disabled={disabled}
                  placeholder={"Старт робіт"}
                  onChange={(time) =>
                    dispatch(setWorkTime({ param: "startTime", time }))
                  }
                  value={startTime}
                />
                <MyTimePicker
                  disabled={disabled}
                  placeholder={"Кінець робіт"}
                  onChange={(time) =>
                    dispatch(setWorkTime({ param: "endTime", time }))
                  }
                  value={endTime}
                />
              </Space>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Дата виконання">
              <DatePicker
                disabled={disabled}
                style={{ width: "100%" }}
                format="DD.MM.YYYY"
                placeholder="Оберіть дату"
                value={workDate ? dayjs(workDate) : null}
                onChange={(e) => dispatch(setDate(e ? e.toISOString() : ""))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <MyText
              type="primary"
              text={"Виберіть працівників що виконували роботу"}
            />
            <SearchSelectDebounce
              disabled={disabled}
              prefix={<TeamOutlined />}
              onChange={(e) => {
                const userIds = (Array.isArray(e) ? e : [])
                  .filter(Boolean)
                  .map((el) => el?.value ?? el)
                  .filter(Boolean);
                const usersData = userIds.map((user) => {
                  const json = user.split("___")[0];
                  const raw = JSON.parse(json);
                  return raw;
                });

                dispatch(setUsers(usersData));
              }}
              customFetch={getAllUsersToSelect}
              mode="multiple"
              value={users.map((el) => {
                return {
                  value: JSON.stringify(el) + `___` + el.id,
                  label: el.name,
                };
              })}
            />
          </Col>
          <Col span={12}>
            <Form.Item label="Опис робіт">
              <TextArea
                disabled={disabled}
                rows={4}
                placeholder="Опишіть виконані або заплановані роботи"
                value={description}
                onChange={(e) => dispatch(setDescription(e.target.value))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Tabs
              className="my-custom-materials-tabs"
              defaultActiveKey="1"
              items={[
                {
                  label: `Виберіть роботи`,
                  key: 1,

                  children: (
                    <div
                      ref={setWorksNodeRef}
                      style={{
                        border:
                          isWorksOver &&
                          activeItem.type === "works" &&
                          `2px solid ${defaultSettings.colorPrimary}`,
                        padding: isWorksOver && "20px",
                        borderRadius: isWorksOver && "20px",
                      }}
                    >
                      <ChooseWorks
                        title=""
                        disabled={disabled}
                        onChange={(worksData) =>
                          dispatch(setSelectedWorks(worksData))
                        }
                        changeValue={(worksData) =>
                          dispatch(setChangeValue(worksData))
                        }
                        changeComment={(commentData) => {
                          dispatch(setCommentData(commentData));
                        }}
                        selectedWorks={selectedWorks}
                      />
                    </div>
                  ),
                },
                {
                  label: `Матеріали`,
                  key: 2,
                  children: (
                    <div
                      ref={setMaterialsNodeRef}
                      style={{
                        border:
                          isMaterialsOver && activeItem.type === "materials"
                            ? `2px solid ${defaultSettings.colorPrimary}`
                            : undefined,
                        padding: isMaterialsOver ? "20px" : undefined,
                        borderRadius: isMaterialsOver ? "20px" : undefined,
                      }}
                    >
                      <ChooseWorks
                        title=""
                        disabled={disabled}
                        findMaterials={true}
                        fetchFunction={getAllMaterialsForProjectToSelect}
                        onChange={(materialsData) => {
                          dispatch(setSelectedMaterials(materialsData));
                        }}
                        changeValue={(materialsData) =>
                          dispatch(setChangeMaterialsValue(materialsData))
                        }
                        changeComment={(commentData) => {
                          dispatch(setCommentData(commentData));
                        }}
                        selectedWorks={blankMaterials}
                        placeholder="Пошук матеріалів..."
                      />
                    </div>
                  ),
                },
              ]}
            ></Tabs>
          </Col>
        </Row>
      </Col>
    </Form>
  );
};
